import formatDate from '../../../helpers/formatDate';

// Footnote clarifying that the popover stats only cover the selected time period.
export function StatsPeriodFootnote({ startDate, endDate }: { startDate?: Date; endDate?: Date }) {
  return (
    <p className="mt-2 border-t border-gray-100 pt-2 text-xs text-gray-400">
      {startDate && endDate
        ? `Usage from ${formatDate(startDate, true)} to ${formatDate(endDate, true)}`
        : 'All-time usage'}
    </p>
  );
}
